import React, { useMemo, useCallback, useEffect } from 'react'
import AiImageGenerationTabTitle from 'containers/SubSidebar/AiImageContent/components/Title'
import AspectRatioDropdown from 'containers/SubSidebar/AiImageContent/components/AspectRatioDropdown'
import { useSelector } from 'react-redux'
import { aiImageThunks } from 'store/features/aiImage/thunks'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { reconstructOptions } from './utils'
import { dispatch } from 'store'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { IAspectRatioOption } from './types'
import * as Styled from '../styled'

const AiImageGenerationAspectRatio: React.FC = () => {
  const aspectRatios = useSelector(aiImageSelectors.aspectRatios)
  const aspectRatio = useSelector(aiImageSelectors.aspectRatio)
  const defaultDimensions = useSelector(projectDataSelectors.defaultDimensions)

  const aspectRatioOptions = useMemo(
    () => reconstructOptions(aspectRatios),
    [aspectRatios]
  )

  const activeAspectRatioOption = useMemo(
    () =>
      aspectRatioOptions.find(
        aspectRatioOption => aspectRatioOption.key === aspectRatio
      ),
    [aspectRatio, aspectRatioOptions]
  )

  const handleAspectRatioClick = useCallback(
    (option: IAspectRatioOption) => {
      if (aspectRatio !== option.key) {
        dispatch(aiImageThunks.setAspectRatio(option.key))
      }
    },
    [aspectRatio]
  )

  useEffect(() => {
    if (defaultDimensions?.aspectRatioString) {
      dispatch(
        aiImageThunks.setAspectRatio(defaultDimensions.aspectRatioString)
      )
    }
  }, [defaultDimensions?.aspectRatioString])

  if (!aspectRatioOptions.length) {
    return null
  }

  return (
    <Styled.AiImageGenerateOption>
      <AiImageGenerationTabTitle>
        {translate(T.ASPECT_RATIO_LABEL)}
      </AiImageGenerationTabTitle>
      <AspectRatioDropdown
        options={aspectRatioOptions}
        activeOption={activeAspectRatioOption || aspectRatioOptions[0]}
        onOptionClick={handleAspectRatioClick}
      />
    </Styled.AiImageGenerateOption>
  )
}

export default AiImageGenerationAspectRatio
